import { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Check, X } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [pending, setPending] = useState([]);

  const load = async () => {
    try {
      const [s, p] = await Promise.all([api.get("/admin/stats"), api.get("/admin/transactions?status=0")]);
      setStats(s.data);
      setPending(p.data);
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    try {
      await api.post("/admin/transactions/approve", { transaction_id: id });
      toast.success("İşlem onaylandı");
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const reject = async (id) => {
    try {
      await api.post("/admin/transactions/reject", { transaction_id: id });
      toast.success("İşlem reddedildi");
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const Card = ({ label, value, testid }) => (
    <div className="border border-white/10 bg-[hsl(0,0%,7%)] p-5" data-testid={testid}>
      <div className="text-[10px] uppercase tracking-[0.25em] text-white/40 mb-2">{label}</div>
      <div className="font-display font-black text-3xl">{value ?? "—"}</div>
    </div>
  );

  return (
    <AdminLayout>
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-2">Admin</div>
        <h1 className="font-display text-3xl font-black">Genel Bakış</h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        <Card label="Kullanıcı" value={stats?.users_count} testid="stat-users" />
        <Card label="Bekleyen Onay" value={stats?.pending_transactions} testid="stat-pending" />
        <Card label="Toplam Numara" value={stats?.total_numbers} testid="stat-numbers" />
        <Card label="Toplam Yükleme" value={`₺${Number(stats?.total_deposited || 0).toFixed(2)}`} testid="stat-deposited" />
      </div>

      <div className="border border-white/10 bg-[hsl(0,0%,7%)]">
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-white/40">Aksiyon Bekliyor</div>
            <div className="font-display font-bold text-lg">Bekleyen Bakiye Bildirimleri</div>
          </div>
          <Link to="/yonetimvolki35/transactions" className="text-xs uppercase tracking-[0.2em] text-white/50 hover:text-white transition-colors" data-testid="link-all-tx">
            Tüm İşlemler →
          </Link>
        </div>
        {pending.length === 0 ? (
          <div className="p-8 text-center text-sm text-white/40">Bekleyen bildirim yok.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="text-[10px] uppercase tracking-[0.2em] text-white/40 border-b border-white/10">
              <tr>
                <th className="text-left py-3 px-5 font-bold">Kullanıcı</th>
                <th className="text-left px-4 font-bold">Yöntem</th>
                <th className="text-right px-4 font-bold">Tutar</th>
                <th className="text-left px-4 font-bold">Referans</th>
                <th className="text-left px-4 font-bold">Tarih</th>
                <th className="text-right px-5 font-bold">İşlem</th>
              </tr>
            </thead>
            <tbody data-testid="pending-tx-table">
              {pending.map((t) => (
                <tr key={t.id} className="border-b border-white/5">
                  <td className="py-3 px-5 font-mono">{t.username}</td>
                  <td className="px-4 uppercase text-xs tracking-wider text-white/70">{t.method}</td>
                  <td className="px-4 text-right font-mono font-bold">₺{Number(t.amount).toFixed(2)}</td>
                  <td className="px-4 text-white/60 text-xs max-w-[200px] truncate" title={t.reference}>{t.reference || "—"}</td>
                  <td className="px-4 text-white/50 text-xs">{new Date(t.created_at).toLocaleString("tr-TR")}</td>
                  <td className="px-5 text-right">
                    <div className="flex justify-end gap-2">
                      <button onClick={() => approve(t.id)} data-testid={`approve-${t.id}`} className="bg-[hsl(142,71%,45%)] hover:bg-[hsl(142,71%,50%)] text-white text-xs px-3 py-1.5 uppercase tracking-wider font-bold transition-colors">
                        <Check className="w-3 h-3 inline mr-1" />Onayla
                      </button>
                      <button onClick={() => reject(t.id)} data-testid={`reject-${t.id}`} className="border border-white/20 hover:border-red-500 hover:text-red-400 text-xs px-3 py-1.5 uppercase tracking-wider transition-colors">
                        <X className="w-3 h-3 inline mr-1" />Reddet
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </AdminLayout>
  );
}
